const photos = (room, n) =>
  Array.from({ length: n }, (_, i) => `/images/tour/${room}_${i + 1}.webp`);

export const TOUR_ROOMS = [
  {
    id: "fachada",
    label: "Fachada",
    photos: photos("fachada", 5),
    features: [
      "Ventanales de aluminio negro",
      "8 niveles con eco elevador",
      "Cajones de estacionamiento a doble altura",
      "Iluminación LED en áreas comunes",
    ],
  },
  {
    id: "sala",
    label: "Sala · Comedor",
    photos: photos("sala", 7),
    features: [
      "Iluminación natural todo el día",
      "Pisos cerámicos",
      "Salida directa a la terraza",
      "Espacio abierto sala-comedor-cocina",
    ],
  },
  {
    id: "cocina",
    label: "Cocina Integral",
    photos: photos("cocina", 7),
    features: [
      "Cocina equipada incluida",
      "Doble tarja y barra desayunadora",
      "Cubierta con estilo y alta resistencia",
      "Cuarto de lavado contiguo",
    ],
  },
  {
    id: "rec1",
    label: "Recámara Principal",
    photos: photos("rec1", 8),
    features: [
      "Baño privado completo",
      "Walking closet",
      "Ventanal de aluminio negro",
      "Espacio para cama king size",
    ],
  },
  {
    id: "rec2",
    label: "Recámara 2",
    photos: photos("rec2", 4),
    features: [
      "Closet amplio",
      "Espacio para cama matrimonial",
      "Ideal como recámara o estudio",
    ],
  },
  {
    id: "bano",
    label: "Baño Completo",
    photos: photos("bano", 3),
    features: [
      "Sanitarios y accesorios de alta gama",
      "Ventilación natural",
    ],
  },
  {
    id: "balcon",
    label: "Balcón · Terraza",
    photos: photos("balcon", 4),
    features: [
      "Terraza privada por departamento",
      "Terraza para disfrutar al aire libre",
      "Piso tipo deck exterior",
    ],
  },
  {
    id: "roof",
    label: "Roof Garden",
    photos: ["/images/tour/roof_1.webp", "/images/roof_new_b.webp", "/images/roof_real_2.webp", "/images/render_roof.webp", "/images/render_roof_2.webp"],
    features: [
      "Asador techado y tarja",
      "Baños en el mismo nivel",
      "164 m² comunes + 2 roof gardens privados",
    ],
  },
  {
    id: "estacionamiento",
    label: "Estacionamiento",
    photos: ["/images/tour/estacionamiento_1.webp", "/images/tour/estacionamiento_2.webp", "/images/tour/estacionamiento_4.webp"],
    features: [
      "1  cajón por departamento independiente",
      "3 cajones para visitas",
      "Cajones a doble altura",
    ],
  },
];

// Coordenadas de hotspots (%) sobre cada plano
export const TOUR_HOTSPOTS = {
  b: {
    balcon: { x: 50, y: 6 },
    rec1: { x: 16, y: 23 },
    rec2: { x: 39, y: 22 },
    sala: { x: 76, y: 24 },
    cocina: { x: 80, y: 55 },
    bano: { x: 59, y: 51 },
  },
  a: {
    cocina: { x: 28, y: 12 },
    bano: { x: 72, y: 14 },
    sala: { x: 22, y: 59 },
    rec2: { x: 59, y: 60 },
    rec1: { x: 86, y: 60 },
    balcon: { x: 33, y: 90 },
  },
};

export const TOUR_SPECS = {
  a: { area: "86.40 m²", rec: "2", banos: "2", cajones: "1", price: "$2,402,100" },
  b: { area: "101.09 m²", rec: "2 + Family Room", banos: "2", cajones: "1", price: "$2,749,920" },
};
